import { COOKIES_POLICY_PATHNAME, DATA_PROCESSING_PATHNAME, IMPRINT_PATHNAME, TERMS_PATHNAME } from '@/shared/constants/pathnames';


export const NAVIGATION_CONFIG = [
    {
        title: "General",
        options: [
            {
                label: "Product",
                href: "#product",
                target: "_self",
            },
            {
                label: "Incidents",
                href: "#report",
                target: "_self",
            },
            {
                label: "Pricing",
                href: "#pricing",
                target: "_self",
            }
        ],
    },
    {
        title: "Support",
        options: [
            {
                label: "Contact",
                href: "#contact",
                target: "_self",
            }
        ],
    },
    {
        title: "Legal",
        options: [
            {
                label: "Terms of service",
                href: TERMS_PATHNAME,
                target: "_blank",
            },
            {
                label: "Data Processing Agreement",
                href: DATA_PROCESSING_PATHNAME,
                target: "_blank",
            },
            {
                label: "Privacy Policy",
                href: IMPRINT_PATHNAME,
                target: "_blank",
            },
            {
                label: "Cookies Policy",
                href: COOKIES_POLICY_PATHNAME,
                target: "_blank",
            },
        ],
    },
];
